import { HTTP } from './http-common';
import { UTILS } from './http-common';
import { privateAPI, privateServiceURL } from '@Base/plugins/axios.js';

export default {
  //obtener moviles de contacto
  getMovilesContacto(token, cbok, cberr) {
    HTTP.get(privateServiceURL + 'auditoria/getMovilesContacto', {
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //obtener estado de la revision
  getEstadoRevision(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/getEstadoRevision',
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumentoAlegacion(idPrestacion, cbok, cberr) {
    return privateAPI({
      url: `auditoria/alegacion/${idPrestacion}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  // obtener textos de la alegación
  getTextosAlegacion(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/alegaciones',
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // obtener subsanacion
  getSubsanacion(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/subsanacion',
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  // obtener subsanacion
  getImagenEjemploDeDocumento(idDocumento, cbok, cberr) {
    return privateAPI({
      url: `auditoria/get-ejemplo-documento/${idDocumento}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  // establecer subsanacion
  putSubsanacion(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/subsanacion',
      method: 'PUT',
      data: null,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  //subir documento
  subirDocumento(documento, cbok, cberr) {
    return privateAPI({
      url: 'auditoria/subir-documento',
      method: 'POST',
      data: documento,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //borrar documento
  borrarDocumento(idDocumento, cbok, cberr) {
    // console.log('borrarDocumento idDocumento: ', idDocumento);
    return privateAPI({
      url: `auditoria/borrar-documento/${idDocumento}`,
      method: 'DELETE',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //obtener comentario
  obtenerComentariosDeCampo(idSolicitud, idCampo, cbok, cberr) {
    return privateAPI({
      url: `comentarios/getComentarios/${idSolicitud}/${idCampo}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //crear comentario
  crearComentarioDeCampo(comentario, cbok, cberr) {
    return privateAPI({
      url: 'comentarios/createComentario',
      method: 'POST',
      data: comentario,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //editar comentario
  editarComentarioDeCampo(comentario, cbok, cberr) {
    return privateAPI({
      url: 'comentarios/updateComentario',
      method: 'PUT',
      data: comentario,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //borrar comentario
  borrarComentarioDeCampo(idComentario, cbok, cberr) {
    return privateAPI({
      url: `comentarios/deleteComentario/${idComentario}`,
      method: 'DELETE',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //obtener declaraciones
  obtenerDeclaraciones(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/declaraciones',
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //actualizar declaraciones
  firmarDeclaraciones(declaraciones, cbok, cberr) {
    return privateAPI({
      url: 'auditoria/declaraciones',
      method: 'POST',
      data: declaraciones,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //preview confirmar subsanación
  getDeclaracionResponsable(notificacionOrigen, cbok, cberr) {
    return privateAPI({
      url: `auditoria/declaracion-responsable/${notificacionOrigen}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  //preview confirmar subsanación
  putConfirmarSubsanacion(cbok, cberr) {
    return privateAPI({
      url: 'auditoria/confirmar-subsanacion',
      method: 'PUT',
      data: null,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // solictiar codigo firma subsanacion
  solicitarCodigoFirmaSubsanacion(signCode, cbok, cberr) {
    return privateAPI({
      url: `auditoria/solicitar-codigo-firma-subsanacion`,
      method: 'POST',
      data: signCode,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // firmar subsanacion
  firmarSubsanacion(signCode, cbok, cberr) {
    return privateAPI({
      url: `auditoria/firmar-subsanacion`,
      method: 'POST',
      data: signCode,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // guarda la observación en la pantalla de subida del documento de la alegación
  setObservacion(documento, cbok, cberr) {
    return privateAPI({
      url: 'auditoria/save-observacion-alegacion',
      method: 'PUT',
      data: documento,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  //  obtener número cuenta original, nuevo, si es valido iban origina....(IBAN)
  getAbonoSolicitud(cbok, cberr) {
    return privateAPI({
      url: `/abonoiban/getAbonoSolicitud`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // gurarda el número de cuenta IBAN
  setNumeroCuentaIban(datosIbanSolicitud, cbok, cberr) {
    return privateAPI({
      url: '/abonoiban/saveAbonoIban',
      method: 'POST',
      data: datosIbanSolicitud,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  // obtiene el documento del abono IBAN
  getDocumentoAbonoIban(idNotificacion, cbok, cberr) {
    return privateAPI({
      url: `/abonoiban/getDocumentoAbonoIban/${idNotificacion}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
};
